import React from 'react';
import SEO from '../components/seo';
import Layout from '../containers/layout/layout';
import Hero from '../containers/home/hero';
import About from '../containers/home/about';
import ServiceSection from '../containers/home/services';
import Process from '../containers/home/process';
import AccentRow from '../components/accentRow';
import ProjectSection from '../containers/home/project';
import TestimonialSlider from '../containers/home/testimonial';
import { graphql } from 'gatsby'

export const homePageSEOData = graphql`
  query homePageSEOQuery {
    sanityHome {
      openGraph {
        title
        description
        image {
          asset {
            url
          }
        }
      }
    }
  }
`;

const HomePage = (props) => {
  const { data } = props
  const pageData = data.sanityHome
  const seoMeta = pageData.seo;
  const openGraph = pageData.openGraph;

  return (
    <Layout headerLayout={2}>
    <SEO
      title={seoMeta?.seo_title}
      ogtitle={openGraph?.title}
      description={seoMeta?.meta_description}
      ogdescription={openGraph?.description}
      image={openGraph?.image?.asset?.fluid}
      pathname={props.location.pathname}
    />
      <Hero />
      <ServiceSection />
      <Process />
      <About />
      <AccentRow />
      <ProjectSection />
      <TestimonialSlider />
    </Layout>
  );
};

export default HomePage